import styles from './Eta.module.css'

export const LocationToError = ({ error }: { error: string }) => (
  <div className={styles.locationToError}>
    {error}
  </div>
)

